import { DataTablePresentationProps } from "@insite/mobius/DataTable";
import DataTableCellBase from "@insite/mobius/DataTable/DataTableCellBase";
import { DataTableHeaderStyle } from "@insite/mobius/DataTable/DataTableHeader";
import { colorPalette, mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

export const dataTable: {
    defaultProps?: DataTablePresentationProps;
} = {
    defaultProps: {
        headerTypographyProps: {
            size: 14,
            weight: "bold",
            lineHeight: 1.43,
            color: colorPalette.common.global.dataTableHeaderColor,
            css: css`
                @media print {
                    color: ${colorPalette.common.global.secondaryGray};
                }
            `,
        },
        sortIconProps: {
            color: colorPalette.common.global.dataTableHeaderColor,
        },
        sortClickableProps: {
            css: css`
                width: auto;
            `,
        },
        cellTypographyProps: {
            size: 14,
            weight: "normal",
            lineHeight: 1.71,
            color: colorPalette.common.global.dataTableRowColor,
        },
        mergeCss: true,
        cssOverrides: {
            row: css`
                background: ${colorPalette.common.global.dataTableRowOddBg};

                ${DataTableCellBase} {
                    padding: 0 14px;
                    height: 42px;
                    border: 0;

                    ${mediaQueriesBP.maxMD} {
                        border-bottom: solid 1px ${colorPalette.common.global.dataTableRowDivider};
                    }

                    ${mediaQueriesBP.minMD} {
                        padding: 0 20px;
                        height: 60px;
                    }

                    @media print {
                        color: ${colorPalette.common.global.secondaryGray};
                        border: solid 1px ${colorPalette.common.global.secondaryGray};
                    }
                }
            `,
            evenRow: css`
                background: ${colorPalette.common.global.dataTableRowEvenBg};
            `,
            head: css`
                ${mediaQueriesBP.maxMD} {
                    border: solid 1px ${colorPalette.common.global.dataTableRowDivider};
                    border-bottom: 0;
                }
            `,
            body: css`
                ${mediaQueriesBP.maxMD} {
                    border: solid 1px ${colorPalette.common.global.dataTableRowDivider};
                    border-bottom: 0;
                    border-top: 0;
                }
            `,
        },
    },
};
